/**
 * @generated SignedSource<<1225863e5140f448a26ee457fae02831>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ValidateProjectIdInput = {
  projectId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ValidateProjectIdMutation$variables = {
  input: ValidateProjectIdInput;
};
export type ValidateProjectIdMutation$data = {
  readonly validateProjectId: {
    readonly valid: string | null;
  } | null;
};
export type ValidateProjectIdMutation = {
  variables: ValidateProjectIdMutation$variables;
  response: ValidateProjectIdMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateProjectIdPayload",
    "kind": "LinkedField",
    "name": "validateProjectId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "valid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValidateProjectIdMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValidateProjectIdMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "418fcb66749e47223efafc08fb909743",
    "id": null,
    "metadata": {},
    "name": "ValidateProjectIdMutation",
    "operationKind": "mutation",
    "text": "mutation ValidateProjectIdMutation(\n  $input: ValidateProjectIdInput!\n) {\n  validateProjectId(input: $input) {\n    valid\n  }\n}\n"
  }
};
})();

(node as any).hash = "e0afdb5228dd9ddeac4ec8fe4ec3e2b5";

export default node;
